export default function Marquee({ children, duration = 60, className = "" }) {
  return (
    <div className={`overflow-hidden ${className}`}>
      <div className="marquee-track" style={{ "--marquee-duration": `${duration}s` }}>
        <div className="flex shrink-0 items-center">{children}</div>
        <div className="flex shrink-0 items-center" aria-hidden="true">{children}</div>
      </div>
    </div>
  );
}
